
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import TableComponentGeneric from '../TableComponentGeneric/TableComponentGeneric.vue'

export default {
    name: "ClientList",
    components: {
        TableComponentGeneric
    },
    setup(){

        const store = useStore()
        const searchInput = ref("")

        const displayData = computed(() => {
            return store.state.main.display_table_data_for_client_list
        })

        const totalAmountOfEntries = computed(() => {
            return store.state.main.original_table_data_for_client_list.entries
        })

        const isAllClientsShown = computed(() => {
            const lessItemsToShowThanDefaultTake = !(store.state.main.display_table_data_for_client_list.entries.length < store.state.main.client_list_take)
            const isMaximumShownReached = !(store.state.main.display_table_data_for_client_list.entries.length === store.state.main.original_table_data_for_client_list.entries.length)
            return isMaximumShownReached && lessItemsToShowThanDefaultTake
        })

        const clientListTakeAmount = ref(store.state.main.client_list_take)

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const searchCustomerList = () => {
            store.dispatch('main/searchClientList', searchInput)
        }

        const showMoreClients = () => {
            store.dispatch('main/showMoreClients')
            
        }

        return {
            getLabel,
            clientListTakeAmount,
            searchCustomerList,
            searchInput,
            totalAmountOfEntries,
            displayData,
            showMoreClients,
            isAllClientsShown
        }
    }
}